import { joinStrings } from 'utilities/functions/array';

export const serializeClasses = joinStrings;
